<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">

                <div class="col-xl-3 col-lg-6">
                    <stats-card :title="$t('member_today')"
                                type="gradient-green"
                                icon="ni ni-chart-bar-32"
                                :sub-title="String(count_report.member_today)"
                                class="mb-4 mb-xl-0"
                    >
                    </stats-card>

                </div>

                <div class="col-xl-3 col-lg-6">
                    <stats-card :title="$t('new_member_today')"
                                type="gradient-orange"
                                :sub-title="String(count_report.member_new)"
                                icon="ni ni-align-left-2"
                                class="mb-4 mb-xl-0"
                    >
                    </stats-card>
                </div>

                <div class="col-xl-3 col-lg-6">
                    <stats-card :title="$t('all_member')"
                                type="gradient-red"
                                :sub-title="String(count_report.member_total)"
                                icon="ni ni-single-02"
                                class="mb-4 mb-xl-0"
                    >

                        <!-- <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
                
                <div class="col-xl-3 col-lg-6">
                    <stats-card :title="$t('billing_today')"
                                type="gradient-info"
                                :sub-title="String(count_report.billing_today)"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >
                    </stats-card>
                </div>
            </div>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card type="default" header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-light text-uppercase ls-1 mb-1">{{$t('this_year')}}</h6>
                                <h5 class="h3 mb-0">{{$t('checkin')}}</h5>
                            </div>
                            <div class="col">
                                <!-- <ul class="nav nav-pills justify-content-end">
                                    <li class="nav-item mr-2 mr-md-0">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{active: bigLineChart.activeIndex === 0}"
                                           @click.prevent="initBigChart(0)">
                                            <span class="d-none d-md-block">Month</span>
                                            <span class="d-md-none">M</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{active: bigLineChart.activeIndex === 1}"
                                           @click.prevent="initBigChart(1)">
                                            <span class="d-none d-md-block">Week</span>
                                            <span class="d-md-none">W</span>
                                        </a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                        <!-- <line-chart
                                :height="350"
                                ref="bigChart"
                                :chart-data="bigLineChart.chartData"
                                :extra-options="bigLineChart.extraOptions"
                        >
                        </line-chart> -->
                        <bar-chart
                                :height="350"
                                ref="barChart"
                                :chart-data="redBarChart4.chartData"
                        >
                        </bar-chart>

                    </card>
                </div>

                <div class="col-xl-4">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase text-muted ls-1 mb-1">{{$t('this_year')}}</h6>
                                <h5 class="h3 mb-0">{{$t('billing')}}</h5>
                            </div>
                        </div>

                        <bar-chart
                                :height="350"
                                ref="barChart"
                                :chart-data="redBarChart.chartData"
                        >
                        </bar-chart>
                    </card>
                </div>
            </div>
            <!-- End charts-->

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-6 mb-5 mb-xl-0">
                    <visits-table></visits-table>
                </div>
                <div class="col-xl-6">
                    <most-table></most-table>
                </div>
            </div>
            <!--End tables-->
        </div>

        
    
        <!-- <modal :show.sync="modal_active" :show-close="false">
            <h2 slot="header" class="modal-title" id="modal-title-default">{{$t('please_confirm_email')}}</h2>

            <p>{{$t('please_check_email_and_click')}}</p>

            <template slot="footer">
                <base-button @click="SendEmailConfirm()" type="primary">{{$t('send_again')}}</base-button>
                <base-button @click="goLogout()" type="danger">{{$t('logout')}}</base-button>
            </template>
        </modal>

        <modal :show.sync="modal_send_email">

            <p>{{$t('please_check_email')}}</p>

            <template slot="footer">
                <base-button @click="modal_send_email = false" type="primary">{{$t('close')}}</base-button>
            </template>

        </modal>  -->


        <modal :show.sync="modal"
               :gradient="modal_setting.gradient"
               modal-classes="modal-danger modal-dialog-centered">
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4"></h4>
                <p>{{modal_setting.alert_text}}</p>
            </div>

            <template slot="footer">
                <base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="modal = false">
                    {{$t('close')}}
                </base-button>
            </template>
        </modal>

    </div>
</template>
<script>
  // import i18n from "@/i18n"
  // Charts
  // import * as chartConfigs from '@/components/Charts/config';
  // import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // Tables
  import MostTable from './Dashboard/MostTable';
  import VisitsTable from './Dashboard/VisitsTable';

  export default {
    components: {
      // LineChart,
      BarChart,
      MostTable,
      VisitsTable,
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        /* modal_active: true,
        modal_send_email: false,
        bigLineChart: {
          allData: [
            [0, 20, 10, 30, 15, 40, 20, 60, 60],
            [0, 20, 5, 25, 10, 30, 15, 40, 40]
          ],
          activeIndex: 0,
          chartData: {
            datasets: [],
            labels: [],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },  */
        redBarChart: {
          chartData: {
            labels: [],
            datasets: [{
              label: '',
              data: []
            }]
          }
        },
        redBarChart2: {
          chartData: {
            labels: [],
            datasets: [{
              label: '',
              data: []
            }]
          }
        },
        redBarChart3: {
          chartData: {
            labels: [],
            datasets: [{
              label: '',
              data: []
            }]
          }
        },
        redBarChart4: {
          chartData: {
            labels: [],
            datasets: [{
              label: '',
              data: []
            }]
          }
        },
        MonthArr: ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        count_report: ''
      };
    },
    created () {
        this.ListItem()
        this.ListItem2()
    },
    methods: {
        /*
        goLogout () {
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/logout')
        },
        SendEmailConfirm () {
            this.$http.post('profile/resendEmail')
                .then(request => this.SendEmailConfirmSuccessful(request))
                .catch(() => this.SendEmailConfirmFailed())
        },
        SendEmailConfirmSuccessful (req) {
            if (req.data.code !== '0') {
                this.SendEmailConfirmFailed(req)
                return
            }
            this.modal_send_email = true
        },
        SendEmailConfirmFailed (req) {
            this.modalAlert(req)
        }, */
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        ListItem () {
            this.$http.get('dashboard/monthly')
            .then(request => this.ListItemSuccessful(request))
            .catch(() => this.ListItemFailed())
        },
        ListItemSuccessful (req) {
            if (req.data.code !== '0') {
                this.ListItemFailed(req)
                return
            }

            for (let i = 0; i < req.data.data.billing.length; i++) {
                this.redBarChart2.chartData.labels.push(+req.data.data.billing[i].month)
                this.redBarChart2.chartData.datasets[0].data.push(req.data.data.billing[i].amount)
            }
            this.redBarChart2.chartData.labels = this.redBarChart2.chartData.labels.map(o => this.MonthArr[o])
            this.redBarChart = this.redBarChart2

            for (let i = 0; i < req.data.data.checkins.length; i++) {
                this.redBarChart3.chartData.labels.push(+req.data.data.checkins[i].month)
                this.redBarChart3.chartData.datasets[0].data.push(req.data.data.checkins[i].count)
            }

            this.redBarChart3.chartData.labels = this.redBarChart3.chartData.labels.map(o => this.MonthArr[o])
            this.redBarChart4 = this.redBarChart3

        },
        ListItemFailed (req) {
            this.modalAlert(req)
        },
        ListItem2 () {
            this.$http.get('dashboard/count')
            .then(request => this.ListItem2Successful(request))
            .catch(() => this.ListItem2Failed())
        },
        ListItem2Successful (req) {
            if (req.data.code !== '0') {
                this.ListItem2Failed(req)
                return
            }

            this.count_report = req.data.data

        },
        ListItem2Failed (req) {
            this.modalAlert(req)
        },
        /* initBigChart(index) {
            let chartData = {
            datasets: [
                {
                label: 'Performance',
                data: this.bigLineChart.allData[index]
                }
            ],
            labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            };
            this.bigLineChart.chartData = chartData;
            this.bigLineChart.activeIndex = index;
        } */
    },
    mounted() {
      // this.initBigChart(0);
    }
  };
</script>
<style></style>
